import { USER_ROLES } from "@/constants";

const mspRoutes = [
  {
    path: "",
    redirect: "/msp/dashboard",
    exact: false,
    meta: {
      authorize: [USER_ROLES.SYSTEM, USER_ROLES.SALES, USER_ROLES.MSP],
    },
  },
  {
    path: "customers",
    exact: false,
    name: "mspOverview",
    component: () => import("@/modules/Customers"),
  },
];
export default mspRoutes;
